module.exports = __webpack_public_path__ + "static/icons/icon-heart-white-214a930954153d56b6d1e053c6cb4855.svg";